import React from 'react'
import Livescore from '../components/ls/Livescore'
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Link} from "react-router-dom";

class Home extends React.Component{

    constructor(props){
        super(props)
        this.state = {
           date : new Date(Date.now() + (3600000*2)).toISOString().slice(0,10) // *2 เพราะให้ตารางสลับแสดงช่วงตี 5
        }
     }

     componentDidMount(){
        //this.setState({date : new Date(Date.now() + (3600000*7)).toISOString().slice(0,10)})
     }

     renderLoader = () => <p>Loading</p>;
     
    
    render() {

        return (
            this.state.date!==null?
        <HelmetProvider>
            <Helmet>
            <title>ผลบอลสด บ้านผลบอล โปรแกรมบอล ครบทุกแมตซ์ MVPKICK</title>
            <meta name="description" content="ตอบโจทย์คอบอลได้ตรงใจ ด้วยตารางบอล ผลบอลสด บ้านผลบอล โปรแกรมบอลคืนนี้ อัพเดทตลอดวัน ครบทุกแมตซ์ รู้บอลเตะก่อนใคร ส่งตรงสู่หน้าจอมือถือและคอมพิวเตอร์ของคุณ ต้องเช็คผลบอลที่ MVPKICK.COM เท่านั้น" />
            <link rel="canonical" href='https://mvpkick.com/' />
            <meta property="og:url" content="https://mvpkick.com/" />
            <meta property="og:title" content="ผลบอลสด บ้านผลบอล โปรแกรมบอล ครบทุกแมตซ์ MVPKICK" />
            <meta property="og:description" content="ตอบโจทย์คอบอลได้ตรงใจ ด้วยตารางบอล ผลบอลสด บ้านผลบอล โปรแกรมบอลคืนนี้ อัพเดทตลอดวัน ครบทุกแมตซ์ รู้บอลเตะก่อนใคร ส่งตรงสู่หน้าจอมือถือและคอมพิวเตอร์ของคุณ ต้องเช็คผลบอลที่ MVPKICK.COM เท่านั้น" />
            <meta property="og:image" content="https://mvpkick.com/img/asset/og-img-main.jpg" />
            </Helmet>
           <div>
           <Livescore selectDate={this.state.date} />
               
               <div className="boxContentPage">
               <div>
                    <h1>เช็คผลบอลคืนนี้ ผลบอลสด โปรแกรมบอลวันนี้ ตารางบอลภาษาไทย</h1>
                    <p>เว็บไซต์ผลบอลสด ผลบอลล่าสุด โปรแกรมบอลคืนนี้ ที่ตอบโจทย์คอลูกหนังได้จริง ต้อง MVPKICK.COM เท่านั้น แหล่งรวมโปรแกรมการแข่งขันกีฬาฟุตบอลจากทั่วโลกมารวมไว้อยู่ในตารางเดียว เรียงตามลำดับความนิยมของทัวร์นาเม้นจากคอลูกหนังทั่วโลก ทำให้หารายการแข่งกลุ่มลีกยอดนิยมได้ง่าย ไม่ต้องเลื่อนหน้าจอหาเยอะให้เสียเวลา เนื่องจากโปรแกรมบอลแต่ละวันมีลงสนามหลายสิบจนถึงหลักร้อยคู่ต่อวัน อาจทำให้ผู้ใช้เสียเวลาเลื่อนหาผลบอลสดในรายการแข่งขันทีมโปรด ทาง MVPKICK จึงจัดลำดับความนิยมแสดงตารางแข่งตามลีกเป็นหลัก นอกจากนี้ หากต้องการดูทุกตารางบอลของวันนี้ สามารถเลือกแสดงโชว์ทุกลีกได้เช่นกัน ปิดเปิดเสียงแจ้งเตือนเมื่อมีสกอร์บอลเกิดขึ้นได้ตามต้องการ รายชื่อทีมรองรับภาษาไทย หาแมตซ์ที่อยากเกาะติดผลบอลสดได้ง่ายๆ ผ่านหน้าจอมือถือและคอมพิวเตอร์ของคุณ อัพเดทสกอร์แบบนาทีต่อนาที รู้ผลเร็วไม่แพ้การดูบอลสดผ่านช่องทีวีดิจิตอล แม่นยำ ตรงจุด ข้อมูลชัวร์สุดในทุกรายละเอียดของเกมส์</p>
                    <p>สิ่งที่ต้องมีคู่กับตารางโปรแกรมบอลสด ผลบอลสด คือรายละเอียดสถิติของแต่ละทีม ข้อมูลสโมสร ข้อมูลนักเตะ รายชื่อผู้เล่นลงสนาม Formation, Odds, H2H นาทีที่มีประตูเกิดขึ้น เหตุการณ์ต่างๆระหว่างเกมที่น่าสนใจ เรารวมทุกเนื้อหาสาระสำคัญในแต่ละแมตซ์ไว้อย่างครบถ้วน สำหรับรายการทัวร์นาเม้นลีกรอง ฟุตบอลเยาวชน บอลแมตซ์กระชับมิตรที่ไม่ได้รับความนิยม อาจมีข้อมูลรายละเอียดบางส่วนไม่ครบ ทางเว็บไซต์อิงจากฐานข้อมูลฟุตบอลสากล แต่สำหรับรายการแข่งในทัวร์นาเม้นยอดฮิต อาทิ อังกฤษพรีเมียร์ลีก ลาลีกาสเปน ลีกเอิงค์ฝรั่งเศส บุนเดสลีก้าเยอรมัน กัลโช่เซเรียอาอิตาลี ยูฟ่าแชมเปี้ยนส์ลีก และกลุ่มดิวิชั่น 1 จากแต่ละประเทศ มั่นใจว่าสถิติมีครบทุกเนื้อหาที่แฟนบอลต้องการเช็คเพื่อนำไปใช้อ้างอิงต่อการวิเคราะห์บอลให้แม่นยำยิ่งขึ้น มองหาเว็บผลบอลวันนี้ บ้านผลบอล สรุปสกอร์บอล ที่ตอบโจทย์จบในเว็บเดียว เลือกเช็คผลบอลสดผ่าน <Link to="/">MVPKICK.COM</Link> เว็บที่เป็นแหล่งข้อมูลให้คอบอลได้ครบทุกความต้องการ</p>
               </div>
               </div>
           </div>
         </HelmetProvider>:
         <div>No Data</div>
        )
     }
}

export default Home;